import { Star } from 'lucide-react';
import { MAX_STARS, matchLabel, matchStars } from '../../utils/matchRank';

/**
 * Three stars: one for the specialty, one for the tools, one for the skills.
 * Filled up to how far this talent got through the job's requirements.
 */
const MatchStars = ({ matched }) => {
  const earned = matchStars(matched);

  return (
    <span
      className='inline-flex items-center gap-0.5'
      title={matchLabel(matched)}
      aria-label={matchLabel(matched)}
    >
      {Array.from({ length: MAX_STARS }, (_, i) => (
        <Star
          key={i}
          size={15}
          className={i < earned ? 'text-amber-500' : 'text-border'}
          fill={i < earned ? 'currentColor' : 'none'}
          aria-hidden
        />
      ))}
    </span>
  );
};

export default MatchStars;
